import { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './skeleton.module.scss';

const getVariableWidth = (width) => {
    const unitMesure = width === null ? '%' : width.match(/^(\d+)(.*)$/)[2];
    const widthValue = width === null ? 100 : parseInt(width.match(/^(\d+)(.*)$/)[1]);
    const lowRange = widthValue / 2;
    return `${parseInt(Math.random() * (widthValue - lowRange) + lowRange)}${unitMesure}`;
};

const Skeleton = (props) => {
    const { width, height, borderRadius, className, num = 1, variableWidth = true } = props;
    const { cercle, linia, imatge, text, titol, boto } = props;
    const [content, setContent] = useState(<></>);

    const stylesSkeletonInLine = {
        borderRadius: borderRadius || null,
        width: width || null,
        height: height || null
    };

    const stylesSkeleton = clsx({
        [styles.skeleton]: true,
        [styles.cercle]: !!cercle,
        [styles.linia]: !!linia,
        [styles.imatge]: !!imatge,
        [styles.text]: !!text,
        [styles.titol]: !!titol,
        [styles.boto]: !!boto,
        [className]: !!className
    });

    useEffect(() => {
        let width = stylesSkeletonInLine.width;
        setContent(
            Array.from({ length: num }, (_, numElement) => {
                if (variableWidth && numElement > 0) {
                    width = getVariableWidth(width);
                    stylesSkeletonInLine.width = width;
                }
                return <div className={stylesSkeleton} style={{ ...stylesSkeletonInLine }} key={`skeleton-${numElement}`}></div>;
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return content;
};

export default Skeleton;
